import { render, staticRenderFns } from "./IncomeSettings.vue?vue&type=template&id=ccd23042&"
import script from "./IncomeSettings.vue?vue&type=script&lang=js&"
export * from "./IncomeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports